import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M1.724 6.904l3.403 2.472-1.3 4a.5.5 0 00.77.56L8 11.463l3.403 2.473a.5.5 0 00.769-.56l-1.3-4 3.403-2.472A.5.5 0 0013.981 6H9.775l-.11-.34L8.474 2a.5.5 0 00-.95 0l-1.3 4H2.017a.5.5 0 00-.294.904z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.586 10.357l5.104 3.708-1.949 6c-.224.69.567 1.266 1.154.839L12 17.194l5.105 3.71c.586.427 1.378-.148 1.153-.84l-1.949-6 5.104-3.707C22 9.93 21.697 9 20.972 9h-6.31l-.166-.51L12.712 3c-.224-.691-1.202-.691-1.426 0l-1.95 6H3.027c-.726 0-1.028.93-.44 1.357z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M5.174 20.714l10.208 7.416-3.898 12c-.448 1.382 1.134 2.532 2.308 1.678L24 34.39l10.21 7.418c1.172.854 2.756-.296 2.306-1.678l-3.898-12 10.208-7.416C44 19.86 43.396 18 41.944 18H29.326l-.332-1.018L25.426 6c-.448-1.382-2.404-1.382-2.852 0l-3.9 12H6.056C4.604 18 4 19.86 5.174 20.714z",
    clipRule: "evenodd"
  }))
};
export var Rating = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});